import { createQuery } from '@tanstack/solid-query'
import ky from 'ky'
import { timestamp } from '~/lib/params'

export const useTimestamp = () => {
  const query = createQuery(() => ({
    queryKey: ['timestamp'],
    queryFn: async () => {
      const res = await ky.get('/time.js?')
      return new Date(Number(new URL(res.url).searchParams.get('ts')) * 1000)
    },
    refetchInterval: 30 * 1000,
    staleTime: Infinity,
    initialData: timestamp,
  }))
  return () => query.data
}
